
import {Component, Vue, Watch} from 'vue-property-decorator';
import {alertModule, authModule} from "@/store";

@Component
export default class Login extends Vue {
  username: string = "";
  password: string = "";
  showAlert: boolean = false;
  showPassword: boolean = false;
  loading: boolean = false;

  rules: any = {
    validUserName: (value: any) => !value || /^[0-9a-zA-Z_.-]+$/.test(value) ||
        "Benutzername darf nur Zeichen wie 'A-Z', '0-9', '_' oder '-' enthalten",
  }

  get loginFailed(): boolean {
    return authModule.hasFailed;
  }

  @Watch('loginFailed')
  onPropertyChanged(newValue: boolean) {
    this.showAlert = newValue;
  }

  async login() {
    this.loading = true;
    this.showAlert = false;

    const loggedIn = await authModule.login({
      userName: this.username,
      password: this.password
    });
    if (loggedIn) {
      await alertModule.dismissAll();

      // empty catch: https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a
      await this.$router.push({name: 'home'}).catch(() => {
      })
    } else {
      this.showAlert = true;
    }

    this.loading = false;
  }

  async passwordRecovery() {
    await this.$router.push("passwordrecovery");
  }

  async mounted() {
    // Going through the store instead of clearing sessionStorage directly: this also drops the
    // in-memory token and resets the modules. Otherwise data of the previous session — study
    // definition and data migration audit logs among it — survives into the next login.
    await authModule.logout();
  }
}
